(() => {
  if (window.acBackNavigationReady) return;
  window.acBackNavigationReady = true;
  let contactOpener;

  function canReturnWithinStore() {
    if (window.history.length < 2) return false;
    try {
      if (window.navigation?.entries && window.navigation.currentEntry) {
        const entries = window.navigation.entries();
        const index = entries.findIndex(entry => entry.key === window.navigation.currentEntry.key);
        const previous = entries[index - 1];
        return Boolean(previous?.url && new URL(previous.url).origin === window.location.origin);
      }
      return Boolean(document.referrer && new URL(document.referrer).origin === window.location.origin);
    } catch {
      return false;
    }
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const menuBack = event.target.closest('[data-ac-menu-back]');
    if (menuBack) {
      const menu = menuBack.closest('details');
      if (menu) {
        menu.open = false;
        menu.querySelector('summary')?.focus();
      }
      return;
    }

    const link = event.target.closest('a');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    if (link.matches('[data-ac-contact]')) {
      const dialog = document.querySelector('[data-ac-contact-dialog]');
      const whatsapp = dialog?.querySelector('[data-ac-contact-whatsapp]');
      if (!(dialog instanceof HTMLDialogElement) || !whatsapp || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      whatsapp.href = link.href;
      const menu = link.closest('.ac-mobile-menu');
      contactOpener = menu?.querySelector('summary') || link;
      if (menu) menu.open = false;
      if (!dialog.open) dialog.showModal();
      return;
    }

    if (link.matches('[data-ac-back]') && canReturnWithinStore()) {
      event.preventDefault();
      window.history.back();
      return;
    }

    if (link.matches('[data-ac-photo]')) {
      const dialog = document.querySelector('[data-ac-photo-dialog]');
      const stage = dialog?.querySelector('[data-ac-photo-stage]');
      if (!(dialog instanceof HTMLDialogElement) || !stage || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      const image = new Image();
      image.alt = link.querySelector('img')?.alt || '';
      image.src = link.href;
      stage.replaceChildren(image);
      dialog.showModal();
      return;
    }

    const menu = link.closest('.ac-mobile-menu');
    if (menu) menu.open = false;
  });

  document.querySelector('[data-ac-photo-dialog]')?.addEventListener('click', event => {
    if (event.target === event.currentTarget) event.currentTarget.close();
  });

  const contactDialog = document.querySelector('[data-ac-contact-dialog]');
  contactDialog?.addEventListener('click', event => {
    if (event.target === event.currentTarget) event.currentTarget.close();
  });
  contactDialog?.addEventListener('close', () => {
    contactOpener?.focus({ preventScroll: true });
  });
})();

